// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9464b11d","455":"f1bee6df","977":"857309e9"}[chunkId] + ".chunk.js";
};